var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loading-page" }, [
    _c("div", { staticClass: "spinner-box-container" }, [
      _vm._m(0),
      _c("span", [_vm._v(_vm._s(_vm.$t("loading")))]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner-box" }, [
      _c(
        "div",
        {
          staticClass: "hollow-dots-spinner",
          staticStyle: { height: "15px", width: "90px" },
          attrs: { "data-v-3411a4c5": "", size: "80" },
        },
        [
          _c("div", {
            staticClass: "dot",
            staticStyle: {
              "animation-delay": "300ms",
              "animation-duration": "1500ms",
              width: "15px",
              height: "15px",
              margin: "0px 7.5px",
              "border-width": "3px",
              "border-color": "rgb(74, 227, 135)",
            },
            attrs: { "data-v-3411a4c5": "" },
          }),
          _c("div", {
            staticClass: "dot",
            staticStyle: {
              "animation-delay": "600ms",
              "animation-duration": "1500ms",
              width: "15px",
              height: "15px",
              margin: "0px 7.5px",
              "border-width": "3px",
              "border-color": "rgb(74, 227, 135)",
            },
            attrs: { "data-v-3411a4c5": "" },
          }),
          _c("div", {
            staticClass: "dot",
            staticStyle: {
              "animation-delay": "900ms",
              "animation-duration": "1500ms",
              width: "15px",
              height: "15px",
              margin: "0px 7.5px",
              "border-width": "3px",
              "border-color": "rgb(74, 227, 135)",
            },
            attrs: { "data-v-3411a4c5": "" },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }